import Signature from './AbstractSignature';
import { CreateElement, VNode } from 'vue';

export default function CurlSignatureFactory(kind: string) {
  switch (kind) {
    case 'api_field':
      return CurlFieldSignature;
    default:
      return {
        getSignature(_method: any): null {
          return null;
        },
      };
  }
}

class CurlFieldSignature extends Signature {
  public static LANG = 'curl';

  public static getSignature(field: any): (h: CreateElement) => VNode {
    return (h) =>
      h('code', [
        `${field.title}`,
        h('span', { class: 'token punctuation' }, ': '),
        field.type
          ? h('span', {
              class: 'token type md-parse',
              domProps: { innerHTML: `${this.convertToHtml(field.type)}` },
            })
          : '',
      ]);
  }
}
